export default __webpack_public_path__ + "static/fountains-a03190bbdfc60565a84f51579fc80cec.jpg";